import { render, staticRenderFns } from "./RTaW.vue?vue&type=template&id=256f0b48"
import script from "./RTaW.vue?vue&type=script&lang=js"
export * from "./RTaW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports